export const initialState = {
  checkoutValue: 0,
  checkoutdata:{},
  paymentsession:{},
  paymentpublicsession:{},
  promiseId: null,
  paymentMethod: null,
  products: null
}